import React, { useState, useEffect } from 'react';
import { Drawer, Avatar, Divider, Button, Skeleton, Descriptions, Input } from 'antd';
import { UnlockOutlined, UserOutlined } from '@ant-design/icons';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useHistory } from 'react-router';
import axios from 'axios';
import Swal from 'sweetalert2';
import _ from 'lodash';
import { useStateValue } from '../../providers/StateProvider';
import ChangePassword from './ChangePassword';
import ChangeTheme from './ChangeTheme';
import { useGetRequest } from '../../hooks';
import { catchRequest } from '../../utils';

const AccountMenuAuditor = () => {
    const [visible, setVisible] = useState(false);
    const [bgColor, setBgColor] = useState('');
    const [{ theme, name = 'Sin Nombre', mail, broken, token, phone }, dispatch] = useStateValue();
    const { data, loading: loadingDatos } = useGetRequest('/api/personal/datosPersonal', [], visible);
    const [red, setRed] = useState({ contrasenia: null, loading: false, contraseniaBuzon: null });
    const [correo, setCorreo] = useState({ contrasenia: null, loading: false, contraseniaBuzon: null });
    const history = useHistory();

    const handleLogout = () => {
        history.push('/');
        axios.post('/general/general/eliminarToken', '', { headers: { Authorization: token } });
        dispatch({ type: 'DELETE_USER_INFO' });
        navigator?.serviceWorker?.getRegistrations().then((registrations) => {
            registrations.forEach((registration) => registration.unregister());
        });
    };

    useEffect(() => {
        setBgColor(`#${ Math.floor(Math.random() * 16777215).toString(16) }`);
    }, []);

    const handleSubmit = (tipo) => {
        if (tipo === 'correo') {
            setCorreo({ ...correo, loading: true });
        } else {
            setRed({ ...correo, loading: true });
        }
        axios.get(`/api/personal/contraseniaPersonal?contrasenia=${ tipo === 'correo' ? correo.contraseniaBuzon : red.contraseniaBuzon }&&tipo=${ tipo }`, { headers: { Authorization: token } })
            .then((res) => {
                _.has(res.data, 'refreshToken') && dispatch({ type: 'ADD_TOKEN', item: { token: res.data.refreshToken } });
                if (res.data.ok) {
                    if (tipo === 'correo') setCorreo({ ...correo, loading: false, contrasenia: res.data.result });
                    else setRed({ ...correo, loading: false, contrasenia: res.data.result });
                } else {
                    if (tipo === 'correo') setCorreo({ ...correo, loading: false });
                    else setRed({ ...correo, loading: false });
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: res.data.message,
                    });
                }
            })
            .catch((e) => { catchRequest(e, dispatch); });
    };

    const handleClose = () => {
        setVisible(false);
        setRed({ contrasenia: null, loading: false, contraseniaBuzon: null });
        setCorreo({ contrasenia: null, loading: false, contraseniaBuzon: null });
    };

    const handleInput = (valor, tipo) => {
        if (tipo === 'correo') {
            setCorreo({ ...correo, contraseniaBuzon: valor });
        } else {
            setRed({ ...red, contraseniaBuzon: valor });
        }
    };

    return (
        <>
            <UserOutlined
                style={{ color: theme === 'dark' ? '#fff' : '', fontSize: 20 }}
                onClick={() => setVisible(true)}
            />
            <Drawer
                title="Perfil"
                placement="right"
                width={broken ? '80%' : 480}
                onClose={() => handleClose()}
                visible={visible}
            >
                <div className="d-flex flex-row">
                    <div className="mr-3">
                        <Avatar
                            size={80}
                            hidden={broken}
                            style={{ backgroundColor: bgColor }}
                            icon={<UserOutlined />}
                        />
                    </div>
                    <div>
                        <h4>{name}</h4>
                        <Button className="p-0" type="link" onClick={handleLogout}>Cerrar sesión</Button>
                    </div>
                </div>
                <Divider />
                <Descriptions title="Acerca de" column={1}>
                    <Descriptions.Item labelStyle={{ fontWeight: '500' }} label="Usuario Buzón">{mail}</Descriptions.Item>
                    <Descriptions.Item labelStyle={{ fontWeight: '500' }} label="Teléfono">{phone || 'Sin asignar'}</Descriptions.Item>
                    <Descriptions.Item labelStyle={{ fontWeight: '500' }} label="Extensión">
                        {loadingDatos ? <Skeleton active paragraph={false} className="m-0 p-0" /> : data?.extension || 'Sin asignar'}
                    </Descriptions.Item>
                    <Descriptions.Item labelStyle={{ fontWeight: '500' }} label="Correo ">
                        {loadingDatos ? <Skeleton active paragraph={false} className="m-0 p-0" /> : data?.correo || 'Sin asignar'}
                    </Descriptions.Item>
                    <Descriptions.Item labelStyle={{ fontWeight: '500' }} label="Contraseña correo">
                        {loadingDatos
                            ? <Skeleton active paragraph={false} className="m-0 p-0" />
                            : data?.contraseniaCorreo
                                ? correo?.contrasenia || (
                                    <div className="d-flex flex-row w-100">
                                        <Input.Password
                                            placeholder="Ingrese su contraseña del buzón"
                                            onChange={(e) => handleInput(e.target.value, 'correo')}
                                            style={{ width: '100%' }}
                                            autoComplete={false}
                                            onPressEnter={() => handleSubmit('correo')}
                                        />
                                        <Button
                                            loading={correo.loading}
                                            disabled={!correo.contraseniaBuzon}
                                            onClick={() => handleSubmit('correo')}
                                            icon={<UnlockOutlined />}
                                        />
                                    </div>
                                )
                                : 'Sin asignar'}
                    </Descriptions.Item>
                    <Descriptions.Item labelStyle={{ fontWeight: '500' }} label="Usuario Red">
                        {loadingDatos ? <Skeleton active paragraph={false} className="m-0 p-0" /> : data?.red || 'Sin asignar'}
                    </Descriptions.Item>
                    <Descriptions.Item labelStyle={{ fontWeight: '500' }} label="Constraseña red ">
                        {loadingDatos
                            ? <Skeleton active paragraph={false} className="m-0 p-0" />
                            : data?.contraseniaRed ? red.contrasenia || (
                                <div className="d-flex flex-row w-100">
                                    <Input.Password
                                        placeholder="Ingrese su contraseña del buzón"
                                        onChange={(e) => handleInput(e.target.value, 'red')}
                                        style={{ width: '100%' }}
                                        autoComplete={false}
                                        onPressEnter={() => handleSubmit('red')}
                                    />
                                    <Button
                                        loading={red.loading}
                                        disabled={!red.contraseniaBuzon}
                                        onClick={() => handleSubmit('red')}
                                        icon={<UnlockOutlined />}
                                    />
                                </div>

                            )
                                : 'Sin asignar'}
                    </Descriptions.Item>
                </Descriptions>
                <Divider />
                <h6 className="mb-3">Ajustes</h6>
                <ChangeTheme />
                <ChangePassword />
            </Drawer>
        </>
    );
};
export default AccountMenuAuditor;
